var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_1337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8229 7.16663C14.5469 7.16663 14.3229 6.94263 14.3229 6.66663C14.3229 4.75195 13.5776 2.95264 12.2242 1.59863C12.0289 1.40332 12.0289 1.08667 12.2242 0.891357C12.4196 0.696045 12.7362 0.696045 12.9316 0.891357C14.4736 2.43396 15.3229 4.48535 15.3229 6.66663C15.3229 6.94263 15.0989 7.16663 14.8229 7.16663Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.15625 7.16663C0.880249 7.16663 0.65625 6.94263 0.65625 6.66663C0.65625 4.48535 1.50562 2.43396 3.04822 0.891968C3.24353 0.696655 3.5603 0.696655 3.75562 0.891968C3.95093 1.08728 3.95093 1.40405 3.75562 1.59937C2.40161 2.95264 1.65625 4.75195 1.65625 6.66663C1.65625 6.94263 1.43225 7.16663 1.15625 7.16663Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98962 16C6.61096 16 5.48962 14.8787 5.48962 13.5C5.48962 13.224 5.71362 13 5.98962 13C6.26562 13 6.48962 13.224 6.48962 13.5C6.48962 14.3274 7.16223 15 7.98962 15C8.81689 15 9.48962 14.3274 9.48962 13.5C9.48962 13.224 9.71362 13 9.98962 13C10.2656 13 10.4896 13.224 10.4896 13.5C10.4896 14.8787 9.36829 16 7.98962 16Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4896 14H2.48962C1.84619 14 1.32288 13.4767 1.32288 12.8334C1.32288 12.4919 1.47156 12.1687 1.73096 11.9467C2.74487 11.09 3.32288 9.84473 3.32288 8.52539V6.66663C3.32288 4.09338 5.41626 2 7.98962 2C10.5629 2 12.6562 4.09338 12.6562 6.66663V8.52539C12.6562 9.84473 13.2343 11.09 14.2416 11.942C14.5076 12.1687 14.6562 12.4919 14.6562 12.8334C14.6562 13.4767 14.1329 14 13.4896 14ZM7.98962 3C5.96753 3 4.32288 4.64465 4.32288 6.66663V8.52539C4.32288 10.1393 3.6156 11.6633 2.38293 12.7053C2.35962 12.7253 2.32288 12.7667 2.32288 12.8334C2.32288 12.924 2.39893 13 2.48962 13H13.4896C13.5802 13 13.6562 12.924 13.6562 12.8334C13.6562 12.7667 13.6196 12.7253 13.5975 12.7067C12.3635 11.6633 11.6562 10.1393 11.6562 8.52539V6.66663C11.6562 4.64465 10.0116 3 7.98962 3Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98962 3C7.71362 3 7.48962 2.776 7.48962 2.5V0.5C7.48962 0.223999 7.71362 0 7.98962 0C8.26562 0 8.48962 0.223999 8.48962 0.5V2.5C8.48962 2.776 8.26562 3 7.98962 3Z",
    fill: "#868686"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_1337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.7ed8bedeea40cb59d5f087913883c757.svg";
export { ForwardRef as ReactComponent };